<template>
  <div class='urlupload oss-upload_source' :class="{IsPartner:IsPartner ==1,NoPartner:IsPartner==0 }">
    <el-dialog
      title="添加链接"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="35%"
      :before-close="handleClose"
      center>
     <el-form label-width='100px'>
         <el-form-item label="资源名称："> 
           <el-input v-model="sourceName" placeholder="请输入资源名称" ></el-input>
           </el-form-item>
         <el-form-item label="资源URL：">
           <el-input placeholder="请输入资源URL" v-model="DocPrviewUrl">
              <!-- <template slot="prepend">Https://</template> -->
            </el-input>
            <!-- <el-input v-model="DocPrviewUrl" placeholder="请输入资源URL" > -->
          </el-form-item>
     </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="cancelSource">取 消</el-button>
    <el-button type="primary" @click="addSource">确 定</el-button>
  </span>
    </el-dialog>
      <el-button size="small" type="primary" @click="createFolderHander">
        <i class="wl-icon-lianjie"></i>
        添加链接
      </el-button>
  </div>

</template>
<script>
export default {
  name: 'Url-Upload-Source',
  props: {},
  data() {
    return {
      dialogVisible: false, 
      sourceName: '',
      DocPrviewUrl: ''
    };
  },
  props: {
    folderId: {
      type: String,
      default: ''
    },
    IsPartner: {
      type: Number,
      default: 0
    },
    CourseId: {
      Type: String,
      default: ''
    },
    SchoolCourseTypeId: {
      Type: String,
      default: ''
    }
  },
  methods: {
    handleClose(done) {},
    createFolderHander() {
      this.dialogVisible = true;
    },
    cancelSource() {
      this.sourceName = '';
      this.DocPrviewUrl='';
      this.dialogVisible = false;
    },
    addSource() {
      if (!this.sourceName) {
        this.$message.warning('资源名称不允许为空');
        return false;
      }
      this.$http.post('/api/XOrg/BookMaterial/saveUrlSource',{
        DocPrviewUrl: this.DocPrviewUrl,
        CourseWareName: this.sourceName,
        FolderId: this.folderId,
        CourseId: this.CourseId,
        IsPartner: this.IsPartner,
        SchoolCourseTypeId: this.SchoolCourseTypeId
      }).then( rst => {
        if (rst.code>0) {
          this.sourceName = '';
          this.DocPrviewUrl='';
          this.dialogVisible = false;
          this.$message.success(rst.msg);
          this.$emit('done');
        } else {
          this.$message.warning(rst.msg);
        }
      })
    }
  }
};
</script>


